












































































































































































































































































































































































































































































































































































































































































































import Vue, { VueConstructor } from "vue";
import User from "@/models/Users/User";
import { Dictionary } from "vuex";
import { IMsgr, ICodes } from "@/types/entity/RawUser";
import {
  CONF_VK_COMMUNITY_LINK,
  CONF_MAX_BOT_NAME,
  CONF_TG_BOT_NAME,
  MSGR_VK,
  MSGR_TG,
  MSGR_MAX,
  MSGR_VB,
  MSGR_TT,
  MSGR_TAMTAM,
  CONF_VB_BOT_NAME,
  CONF_TAMTAM_BOT_NAME,
  CONF_MESSENGER_MAX,
  CONF_MESSENGER_VK,
  CONF_MESSENGER_TG,
  CONF_MESSENGER_VB,
  CONF_MESSENGER_TAMTAM,
  MSGR_DISCORD,
  CONF_DISCORD_BOT_NAME,
  CONF_MESSENGER_DISCORD,
  CONF_DC_APP_NAME,
  CONF_DC_APP_LINK,
  CONF_DC_APP_AUTHLINK,
} from "@/constants";
import config from "@/config";
import UiTimer from "@/components/Ui/Timer/Timer.vue";
import UiSwitch from "@/components/Ui/Switch/switch.vue";
import _ from "lodash";

// @ts-ignore
import messages from "@/lang/index";

const MSGR_DICT: { [key: string]: string } = {
  [MSGR_MAX]: 'MAX',
  // [MSGR_MAX]: messages.messeger.messengers.max,
  [MSGR_VK]: messages.messeger.messengers.vk,
  [MSGR_TG]: messages.messeger.messengers.tg,
  [MSGR_VB]: messages.messeger.messengers.vb,
  [MSGR_TAMTAM]: messages.messeger.messengers.tamtam,
  [MSGR_DISCORD]: messages.messeger.messengers.discord,
};
export default (Vue as VueConstructor<
  Vue & {
    $copyText: (text: string) => void;
  }
>).extend({
  components: {
    UiTimer,
    UiSwitch,
  },
  data() {
    return {
      popupVisible: {
        [MSGR_MAX]: false,
        [MSGR_VK]: false,
        [MSGR_TG]: false,
        [MSGR_VB]: false,
        [MSGR_TT]: false,
        [MSGR_DISCORD]: false,
      } as { [key: string]: boolean },
      confirmVisible: {
        [MSGR_MAX]: false,
        [MSGR_VK]: false,
        [MSGR_TG]: false,
        [MSGR_VB]: false,
        [MSGR_TT]: false,
        [MSGR_DISCORD]: false,
      } as { [key: string]: boolean },
      VK_COMMUNITY_LINK: config(CONF_VK_COMMUNITY_LINK),
      MAX_BOT_NAME: config(CONF_MAX_BOT_NAME),
      TG_BOT_NAME: config(CONF_TG_BOT_NAME),
      VB_BOT_NAME: config(CONF_VB_BOT_NAME),
      TAMTAM_BOT_NAME: config(CONF_TAMTAM_BOT_NAME),
      DISCORD_BOT_NAME: config(CONF_DISCORD_BOT_NAME),
      DC_APP_NAME: config(CONF_DC_APP_NAME),
      DC_APP_LINK: config(CONF_DC_APP_LINK),
      DC_APP_AUTHLINK: config(CONF_DC_APP_AUTHLINK),
      MSGR_MAX,
      MSGR_VK,
      MSGR_TG,
      MSGR_VB,
      MSGR_TT,
      MSGR_TAMTAM,
      MSGR_DISCORD,
      interval: null,
    };
  },
  computed: {
    msgr(): Dictionary<IMsgr> | false {
      if (this.user) {
        return this.user.getMsgr();
      } else {
        return false;
      }
    },
    codes(): Dictionary<ICodes> {
      if (this.user) {
        return this.user.getCodes();
      } else {
        return {};
      }
    },
    user(): User | false {
      return this.$store.state.user.user;
    },
    serverTime(): number {
      return this.$store.state.serverTime;
    },
    isShowMAX(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_MAX);
    },
    isShowVK(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_VK);
    },
    isShowTG(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_TG);
    },
    isShowVB(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_VB);
    },
    isShowTamTam(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_TAMTAM);
    },
    isShowDiscord(): boolean {
      return this.isShowMessenger(CONF_MESSENGER_DISCORD);
    },
  },
  methods: {
    isShowMessenger(messengerName: string) {
      const messenger = config(messengerName);

      if (!messenger) {
        return false;
      }

      return messenger === "true" || messenger === "TRUE" || messenger === true;
    },
    async onMsgrClick(msgr: string) {
      const msg = msgr === "tamtam" ? "tt" : msgr;

      try {
        if (this.msgr) {
          console.log(1)
          if (!this.msgr[msg]) {
            console.log(2)
            if (!this.codes[msg]) {
              console.log(3)
              await this.getCode(msg);
            }
            console.log(4)
            this.openModal(msgr);
          } else {
            this.authDrop(msg);
          }
        }
      } catch (error) {
        console.error("LOG: onMsgrClick -> error", error);
      }
    },
    async openModal(msgr: string) {
      this.popupVisible[msgr] = true;
    },
    async authDrop(msgr: string) {
      try {
        // @ts-ignore
        await this.$confirm(
          `${this.$t("messeger.sure_disable_notifications_in")} ${
            MSGR_DICT[msgr === "tt" ? "tamtam" : msgr]
          }`,
          this.$t("labels.attention").toString(),
          {
            confirmButtonText: this.$t("labels.disable").toString(),
            cancelButtonText: this.$t("labels.cancel").toString(),
            type: "warning",
          }
        );
        // @ts-ignore
        this.$message({
          type: "success",
          // @ts-ignore
          message: this.$t("messeger.notifications_disabled"),
        });
        await this.$store.dispatch("user/dropAuth", { msgr });
        await this.reloadUser();
      } catch (e) {
        console.log(e);
      }
    },
    async getCode(msgr: string): Promise<void> {
      try {
        if (msgr) {
          await this.$store.dispatch("user/getCode", { msgr });
          await this.reloadUser();
        }
      } catch (error) {
        console.error("getCode", error);
        // @ts-ignore
        this.$message.error(this.$t("messeger.can_not_send_code"));
      }
    },
    async reloadUser(): Promise<void> {
      await this.$store.dispatch("user/loadUser", true);
    },
    // @ts-ignore
    async copyText(text: string, target = this.$t("news.code_copyied")) {
      try {
        this.$copyText(text);
        // @ts-ignore
        this.$message.success(`${target} ${this.$t("news.to_buffer")}`);
      } catch (error) {
        // @ts-ignore
        this.$message.warning(this.$t("messeger.can_not_copy_code"));
      }
    },
    onTimerExpired(): void {
      this.reloadUser();
    },
    showConfirm(msgr: string) {
      console.log("LOG: showConfirm -> msgr", msgr);
      this.confirmVisible[msgr] = true;
    },
    closeAllPopups() {
      for (let key in this.popupVisible) {
        this.popupVisible[key] = false;
      }
    },
    closeConfirm(msgr: string) {
      this.confirmVisible[msgr] = false;
    },
    userDataWatcher(): void {
      // @ts-ignore
      this.interval = setInterval(() => {
        this.reloadUser();
      }, 4000);
    },
  },
  mounted() {
    this.userDataWatcher();
  },
  watch: {
    msgr(newVal, oldVal) {
      if (!oldVal) return;
      let newKeys = Object.keys(newVal);
      let oldKeys = Object.keys(oldVal);
      let diffKeys = _.difference(newKeys, oldKeys);
      if (diffKeys.length) {
        this.closeAllPopups();
        for (const msgr of diffKeys) {
          this.showConfirm(msgr);
        }
      }
    },
  },
  beforeDestroy() {
    // @ts-ignore
    clearInterval(this.interval);
  },
});
